import CloseIcon from "@mui/icons-material/Close";
import "./SharedPartiesModal.css";
import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  // Chip,
  Button,
  FormControl,
  Input,
  InputAdornment,
  // InputLabel,
  // ListItem,
  Modal,
  // Paper,
} from "@mui/material";
// import ListBox from "../../../components/User/PropertyDetails/SharedModalComponent/ListBox/ListBox";
// import SharedPartiesListBox from "./SharedPartiesListBox/SharedPartiesListBox";
// import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from "@mui/icons-material/Search";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../helpers/stringAvatar";
import {
  client,
  // MultipleQueryTypesense,
  // QueryTypesense,
} from "../../../Typesense";
import UpdateProperty from "../../../controllers/properties/updateProperty";
// import { refreshContext } from "../Properties";
// Modal Start
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #cccccc",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
};

const SharedPartiesModal = ({
  OpenSharedPartiesModal,
  handleCloseSharedPartiesModal,
  property,
}) => {
  const [Loader, setLoader] = useState(false);
  // const { sharedParties } = property;

  const [Search, setSearch] = useState("");
  const [SharedParties, setSharedParties] = useState([]);

  // const refreshData = useContext(refreshContext);

  useEffect(() => {
    const fetch = async () => {
      const parties = property.sharedParties || [];

      for (let index = 0; index < parties.length; index++) {
        if (typeof parties[index] === "string")
          parties[index] = await client
            .collections("clients")
            .documents(parties[index])
            .retrieve();
      }

      setSharedParties([...parties]);
    };
    fetch();
  }, [handleCloseSharedPartiesModal, property]);

  const removeParty = (_id) =>
    setSharedParties([...SharedParties.filter(({ id }) => id !== _id)]);

  const removeAll = () => setSharedParties([]);

  const updateShareParties = async () => {
    setLoader(true);
    let status = "shared";
    const { id } = property;
    if (SharedParties.length === 0) {
      status = "inventory";
      var letsAt = null;
    }

    UpdateProperty(id, {
      status: status,
      sharedAt: letsAt === null ? letsAt : property.sharedAt,
      numberOfSharedParties: SharedParties.length,
      sharedParties: [...SharedParties.map(({ id: _id }) => _id)],
    }).then(() => {
      handleCloseSharedPartiesModal();
      setLoader(false);
    });
  };

  return (
    <Fragment>
      <div>
        <Modal
          open={OpenSharedPartiesModal}
          onClose={handleCloseSharedPartiesModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="shared-parties-model" sx={style}>
            <div className="shared-parties-model-heading-div">
              <div className="shared-parties-model-heading">
                <p>Shared With</p>
              </div>

              <span
                className="shared-parties-model-cross-button"
                onClick={handleCloseSharedPartiesModal}
              >
                <CloseIcon />
              </span>
            </div>
            <div className="shared-parties-model-header-divider">
              <hr className="hr m-0 my-2" />
            </div>
            <Fragment>
              <div className="shared-parties-model-dealer-div">
                <div>
                  <p className="shared-parties-model-dealer-paragraph">
                    Share With ({SharedParties.length}) Dealers
                  </p>
                </div>

                <div className="shared-parties-model-remove-all-div">
                  <p
                    className="shared-parties-model-remove-all"
                    onClick={removeAll}
                  >
                    {/* {checked ? "All Selected" : "Select All"} */}
                    Remove All
                  </p>
                </div>
              </div>
              <FormControl
                variant="standard"
                fullWidth
                className="share-container"
              >
                <Input
                  className="shared-parties-model-input"
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  id="component-simple"
                  placeholder="Search For Dealers"
                  // value={name}
                  onChange={(e) => setSearch(e.target.value)}
                  // onChange={(e) => setSearchText(e.target.value)}
                />

                <div className="shared-parties-model-main-div">
                  <div className="shared-parties-model-main-div-divider">
                    <hr className="hr m-0 my-2" />
                  </div>
                  {SharedParties.filter(({ businessName }) =>
                    Search === ""
                      ? true
                      : businessName.toLowerCase().includes(Search)
                  ).map(({ businessName, uid, id, image_url }) => (
                    <>
                      <div
                        className="shared-parties-list"
                        //  onClick={() => handleClickSharedParty(id)}
                      >
                        <div className="shared-parties-list-names">
                          {image_url ? (
                            <div
                              className="shared-parties-list-images"
                              style={{ backgroundImage: `url(${image_url})` }}
                            ></div>
                          ) : (
                            <Avatar
                              {...stringAvatar(businessName)}
                              className="AgentAvatar"
                            />
                          )}
                          <h5 className="shared-parties-list-headings">
                            {businessName}
                          </h5>
                        </div>
                        <div>
                          <button
                            id=""
                            onClick={() => removeParty(id)}
                            className="shared-parties-list-remove-btn"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                      <div className="shared-parties-model-main-div-divider ">
                        <hr className="hr m-0 my-2" />
                      </div>
                    </>
                  ))}
                </div>
              </FormControl>
            </Fragment>
            <div className="shared-parties-model-confirm-div">
              <button
                className="shared-parties-model-confirm-btn"
                onClick={updateShareParties}
                disabled={Loader}
              >
                {Loader && (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                )}{" "}
                Confirm
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </Fragment>
  );
};

export default SharedPartiesModal;
